module.exports = __webpack_public_path__ + "static/img/twin-wateway-3.db8326bf.png";